export interface ApiError {
  status?: number;
  code: string;
  message: string;
  fields?: Record<string, string[]>;
  details?: unknown;
  cause?: unknown;
}

export const isApiError = (value: unknown): value is ApiError => {
  if (!value || typeof value !== "object") return false;
  const candidate = value as Partial<ApiError>;
  return typeof candidate.code === "string" && typeof candidate.message === "string";
};
